import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    DoneTwoTone,
    NotInterestedTwoTone,
    SystemUpdateAltTwoTone
} from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {BlueButton, GreenButton, GreyButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    deleteNonconformance, approve,
    nonconformance,
    nonconformanceRevision, disapprove,
    saveOrUpdateNonconformance,
    uploadMultipleFiles, deleteFile, addNonconformanceRevision
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Dropzone from "react-dropzone";
import {Table, TableHead} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import * as ApiUtils from "../../util/ApiUtils";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";
import {expiredDateStyle} from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: 'Identifier',
        id: 'identifier',
        type: "text",
    },
    {
        name: 'Brief Details',
        id: 'details',
        type: "text",
    },
    {
        name: 'Date NCR lodged',
        id: 'displayDate',
        type: "text",
    },
    {
        name: 'NC Status',
        id: 'displayStatus',
        type: "text",
    },
    {
        name: 'Date the NC corrections due',
        id: 'displayDueDate',
        type: "text",
        cellStyle: (cellData) => {
            if (cellData.item.status === 'In Progress') {
                return {
                    width: '15%',
                    ...expiredDateStyle(cellData.value)
                }
            }
        }
    },
];

class NonconformanceRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nonconformanceAction: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            date: null,
            dueDate: null,
            id: null,
            identifier: "",
            formCompletedBy: "",
            approvedBy: "",
            position: "",
            nonConforming: false,
            audit: false,
            complaint: false,
            improvementIdentified: false,
            details: "",
            cause: "",
            actionTaken: "",
            similarNonconformities: "",
            rootCauseAnalysis: "",
            status: "In Progress",
            selectedFiles: [],
            files: [],
        };
        this.loadNonConformanceRegister = this.loadNonConformanceRegister.bind(this);
        this.loadNonConformanceRegisterRevision = this.loadNonConformanceRegisterRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.approve = this.approve.bind(this);
        this.disapprove = this.disapprove.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.deleteFileFromAction = this.deleteFileFromAction.bind(this);
        this.addRevision = this.addRevision.bind(this);
    }

    deleteFileFromAction(fileId) {
        console.log("this.state.id", this.state.id);
        console.log("fileId", fileId);
        deleteFile("/nonconformance/deleteFile", this.state.id, fileId)
            .then(() => {
                const remainingFiles = this.state.files.filter(function(file) {
                    return file.id !== fileId;
                });
                this.setState({
                    files: remainingFiles,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    onDrop(files) {
        let selectedFiles = this.state.selectedFiles;
        files.map(file => selectedFiles.push(file));
        this.setState({
            selectedFiles: selectedFiles
        });
    }

    addRevision(request) {
        addNonconformanceRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadNonConformanceRegister();
        this.loadNonConformanceRegisterRevision();
    }

    loadNonConformanceRegisterRevision() {
        nonconformanceRevision()
            .then(response => {
                console.log(response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadNonConformanceRegister() {
        nonconformance()
            .then(response => {
                console.log('this.loadNonConformanceRegister(); response');
                console.log(response);
                this.setState({
                    nonconformanceAction: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(actionRecord) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: actionRecord.id,
            identifier: actionRecord.identifier,
            date: actionRecord.date,
            header: `${actionRecord.identifier} - ${actionRecord.status}` ,
            formCompletedBy: actionRecord.formCompletedBy,
            position: actionRecord.position,
            nonConforming: actionRecord.nonConforming,
            approvedBy: actionRecord.approvedBy,
            audit: actionRecord.audit,
            complaint: actionRecord.complaint,
            improvementIdentified: actionRecord.improvementIdentified,
            status: actionRecord.status,
            details: actionRecord.details,
            cause: actionRecord.cause,
            actionTaken: actionRecord.actionTaken,
            similarNonconformities: actionRecord.similarNonconformities,
            rootCauseAnalysis: actionRecord.rootCauseAnalysis,
            dueDate: actionRecord.dueDate,
            files: actionRecord.files,
            selectedFiles: [],
        })
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: null,
            identifier: "",
            date: null,
            formCompletedBy: "",
            approvedBy: "",
            position: "",
            nonConforming: false,
            audit: false,
            complaint: false,
            improvementIdentified: false,
            status: "In Progress",
            header: "New Action",
            details: "",
            cause: "",
            actionTaken: "",
            similarNonconformities: "",
            rootCauseAnalysis: "",
            dueDate: null,
            selectedFiles: [],
            files: [],
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            id: null,
            identifier: "",
            date: null,
            dueDate: null,
            formCompletedBy: "",
            position: "",
            nonConforming: false,
            audit: false,
            complaint: false,
            improvementIdentified: false,
            status: "In Progress",
            header: "New Action",
            selectedFiles: [],
        });
        this.loadNonConformanceRegister();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteNonconformance(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success('Success', 'The Nonconformance Action has been removed.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave() {
        console.log(this.state);
        saveOrUpdateNonconformance(this.state)
            .then((updatedRecord) => {
                console.log("updatedRecord id " + updatedRecord.id);
                console.log("updatedRecord " + updatedRecord);
                console.log(this.state);
                if (this.state.selectedFiles.length > 0) {
                    uploadMultipleFiles('/nonconformance/fileUpload', updatedRecord.id, this.state.selectedFiles, () => {
                        NotificationManager.success('Success', 'The Nonconformance Action has been updated.', 5000);
                        this.reset();
                    });
                } else {
                    NotificationManager.success('Success', 'The Nonconformance Action has been updated.', 5000);
                    this.reset();
                }
            }).catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    approve() {
        approve(this.state)
            .then((updatedRecord) => {
                console.log("updatedRecord id " + updatedRecord.id);
                console.log("updatedRecord " + updatedRecord);
                console.log(this.state);
                NotificationManager.success('Success', 'The Nonconformance Action has been updated.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    disapprove() {
        disapprove(this.state)
            .then((updatedRecord) => {
                console.log("updatedRecord id " + updatedRecord.id);
                console.log("updatedRecord " + updatedRecord);
                console.log(this.state);
                NotificationManager.success('Success', 'The Nonconformance Action has been updated.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleChange = name => event => {
        console.log(name);
        this.setState({ [name]: event.target.checked });
        console.log(name !== 'nonConforming');
        console.log(name !== 'audit');
        console.log(name !== 'complaint');
        console.log(name !== 'improvementIdentified');
        if (name !== 'nonConforming') {
            this.setState({ nonConforming: false });
        }
        if (name !== 'audit') {
            this.setState({ audit: false });
        }
        if (name !== 'complaint') {
            this.setState({ complaint: false });
        }
        if (name !== 'improvementIdentified') {
            this.setState({ improvementIdentified: false });
        }
        console.log(this.state);
    };

    handleTextChange({ target }) {
        console.log('target.value');
        console.log(target.value);
        this.setState({
            ...this.state, [target.name]: target.value
        });
        console.log('this.state')
        console.log(this.state)
    }

    onDateChange(date, fieldName) {
        console.log('fieldName', fieldName); //whatever the date the user picked
        console.log('moment(date, "DD/MM/YYYY")', moment(date, "DD/MM/YYYY"));
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        const fileNames = this.state.selectedFiles.map((file) => (
            <li key={file.name}>
                {file.name}
            </li>
        ));

        return <div>
            <Typography component="h2" variant="h5">
                NONCONFORMANCE / CORRECTIVE ACTION REGISTER
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                    <CardHeader
                        action={
                            <BlueButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleOutlineTwoTone/>}
                                onClick={this.showModal}
                                size="small"
                                style={{marginRight: '10px'}}
                                disabled={isAuditor}
                            >
                                ADD
                            </BlueButton>
                        }
                        title={
                            <span style={{color: "darkblue"}}>
                                <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                            </span>
                        }
                    />
                    :
                        <CardHeader
                            style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                            title={
                                <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                            }
                        />
                    )}
                    <CardContent>
                        {(!state.isEditing ?
                            <div>
                                {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/nonconformance/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                                <TableComponent
                                    tableKey="nonconformanceCorrectiveActionRegister"
                                    data={state.nonconformanceAction}
                                    columns={columns}
                                    handleSubmit={this.handleSubmit}
                                    handleAddRow={this.handleAddRow}
                                    handleRowDel={this.onDelete}
                                    handleRowEdit={this.onEdit}
                                    allowAdd={isRevision && !isAuditor ? 'show' : 'disable'}
                                    pagination={true}
                                    allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                />
                            </div>
                            :
                            <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    <div>
                                        { !state.isNew && !isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/nonconformance/export/' + state.id)} style={{ float: 'right' }}>EXPORT</GreenButton> }
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="date"
                                                label="Date NCR lodged"
                                                name="date"
                                                value={state.date}
                                                onChange={(event) => this.onDateChange(event, 'date')}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: "600px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="formCompletedBy"
                                            name="formCompletedBy"
                                            value={state.formCompletedBy}
                                            label="Name of person completing the form"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="position"
                                            name="position"
                                            value={state.position}
                                            label="Position"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                        <FormLabel component="legend">Please tick the appropriate box:</FormLabel>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox checked={state.nonConforming} onChange={this.handleChange('nonConforming')} value={state.nonConforming} />}
                                                label="Non conforming product / service"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={state.audit} onChange={this.handleChange('audit')} value={state.audit} />}
                                                label="Audit (internal / external)"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={state.complaint} onChange={this.handleChange('complaint')} value={state.complaint} />
                                                }
                                                label="Complaint"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={state.improvementIdentified} onChange={this.handleChange('improvementIdentified')} value={state.improvementIdentified} />
                                                }
                                                label="Area of improvement identified."
                                            />
                                        </FormGroup>
                                    </FormControl>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="standard-multiline-static"
                                            label="Details of the issue identified"
                                            name="details"
                                            value={state.details}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows="4"
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="standard-multiline-static"
                                            label="What was the cause of nonconformity"
                                            name="cause"
                                            value={state.cause}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows="4"
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="standard-multiline-static"
                                            label="Determine if similar nonconformities exist, or could potentially occur"
                                            name="similarNonconformities"
                                            value={state.similarNonconformities}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows="4"
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="standard-multiline-static"
                                            label="Root cause analysis"
                                            name="rootCauseAnalysis"
                                            value={state.rootCauseAnalysis}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows="4"
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="standard-multiline-static"
                                            label="Action taken to prevent this from happening again"
                                            name="actionTaken"
                                            value={state.actionTaken}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows="4"
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="dueDate"
                                                label="DUE DATE FOR THE CORRECTIVE ACTION (CA)"
                                                name="dueDate"
                                                value={state.dueDate}
                                                onChange={(event) => this.onDateChange(event, 'dueDate')}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                style={{ width: "600px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                {
                                    (state.files && state.files.length > 0) &&
                                        <div style={{ width: "800px", paddingTop: "30px" }}>
                                            <Table>
                                                <TableHead>
                                                    <tr style={{ float: "left" }}>
                                                        <th colSpan={3} style={{ textAlign: "center" }}>UPLOADED DOCUMENTS:</th>
                                                    </tr>
                                                </TableHead>
                                                <TableBody>
                                                    {console.log('here 1', state.files)}
                                                    {state.files.map((file) => (
                                                        <tr key={file.id}>
                                                            <td>{file.name}</td>
                                                            <td><GreyButton onClick={() => ApiUtils.downloadFile(file.id)}>DOWNLOAD</GreyButton></td>
                                                            <td><RedButton onClick={() => this.deleteFileFromAction(file.id)}>REMOVE</RedButton></td>
                                                        </tr>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                }
                                    <div style={{ width: "800px", minHeight: "100px", paddingTop: "30px"}}>
                                        <Dropzone onDrop={(files) => this.onDrop(files)}>
                                            {({getRootProps, getInputProps}) => (
                                                <span>
                                                    <div {...getRootProps()} style={{ verticalAlign: "middle", textAlign: "center", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell", height: "100px", width: "800px"}}>
                                                        <input
                                                            {...getInputProps()}
                                                        />
                                                        <label style={{ /* backgroundColor: '#007bff', color: '#fff',*/ cursor: 'pointer', padding: 15, borderRadius: 3 }}>
                                                            Please Drag and Drop some files here, or click to Select Files
                                                        </label>
                                                    </div>
                                                    {(fileNames.length > 0) &&
                                                        <aside>
                                                            <h4>Selected files:</h4>
                                                            <ul>{ fileNames }</ul>
                                                        </aside>
                                                    }
                                                </span>
                                            )}
                                        </Dropzone>
                                    </div>
                                    {!state.isNew &&
                                        <div style={{ paddingTop: "20px", width: "800px"}}>
                                            <TextField
                                                label="Approved By"
                                                name="approvedBy"
                                                value={state.approvedBy}
                                                onChange={this.handleTextChange}
                                                style={{ width: "400px", float: "right"}}
                                            />
                                        </div>
                                    }
                                    <div style={{ width: "800px", clear: "both"}}>
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onCancel}
                                            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                        >
                                            CANCEL
                                        </OrangeButton>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onSave}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            SAVE
                                        </GreenButton>
                                        {(!state.isNew &&
                                            ((state.status === 'In Progress') ?
                                                <span>
                                                    <OrangeButton
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<DoneTwoTone />}
                                                        size="small"
                                                        onClick={this.approve}
                                                        style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: "right" }}
                                                    >
                                                        APPROVED
                                                    </OrangeButton>
                                                    <RedButton
                                                        variant="contained"
                                                        color="secondary"
                                                        startIcon={<NotInterestedTwoTone />}
                                                        size="small"
                                                        onClick={this.disapprove}
                                                        style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: "right" }}
                                                    >
                                                        NOT APPROVED
                                                    </RedButton>
                                                </span>
                                            :
                                            ((state.status === 'Not Approved') ?
                                                <OrangeButton
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<DoneTwoTone />}
                                                    size="small"
                                                    onClick={this.approve}
                                                    style={{ marginTop: '20px', marginBottom: '20px', float: "right" }}
                                                >
                                                    APPROVE
                                                </OrangeButton>
                                            :
                                                <RedButton
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<NotInterestedTwoTone />}
                                                    size="small"
                                                    onClick={this.disapprove}
                                                    style={{ marginTop: '20px', marginBottom: '20px', float: "right" }}
                                                >
                                                    DISAPPROVE
                                                </RedButton>
                                            )
                                        ))}
                                    </div>
                            </div>
                        )}
                    </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(NonconformanceRegister);
